/**
 * Validator for From
 * 
 */
var pleksearch = {

  current_type: null,
  threshold: 40,
  last_search_result: null,
  band_name_timeout: '',

  /**
   * Add eventlistener for search events
   */
  register_eventlistener() {

    jQuery("#filter-country").change((e) => {
      e.preventDefault();
      pleksearch.load_filtered_bands();

    });
    jQuery("#filter-genre").change((e) => {
      e.preventDefault();
      pleksearch.load_filtered_bands();

    });
    jQuery("#filter-band-name").on('input', (e) => {
      e.preventDefault();
      clearTimeout(pleksearch.band_name_timeout);

      pleksearch.band_name_timeout = setTimeout(() => {
        pleksearch.load_filtered_bands();
      }, 500);

    });
  },

  fire_search(element) {
    var search_field_id = jQuery(element).attr('id');
    var type = jQuery('#' + search_field_id).attr('name');
    var result_con = jQuery('#' + type + '_overlay');
    this.set_type_settings(type);
    if (result_con.length == 0) {
      plekerror.display_error('No Result Container found.');
      return;
    }
    result_con.html("<div class='item'><span class='plek_loading'></span>&nbsp;" + __('Loading results...', 'plekvetica') + "</div>");
    var tout = window.plekTimeout;
    window.clearTimeout(tout);
    window.plekTimeout = window.setTimeout(function () {
      window.pleksearch.search(search_field_id).then(function (findings) {
        result_con.html(pleksearch.display_results(findings));
        window.pleksearch.add_item_Eventlistener();
        plektemplate.show_overlay(search_field_id);
      });
    }, 500);
  },

  set_type_settings(type) {
    window.pleksearch.current_type = type;

    switch (type) {
      case 'event_venue':
        window.pleksearch.threshold = 40;
        break;
      case 'event_band':
        window.pleksearch.threshold = 40;
        break;
      case 'event_organizer':
        window.pleksearch.threshold = 40;
        break;

      default:
        break;
    }
    return;
  },

  display_results(result_object) {
    var result = '';
    var total = Object.keys(result_object).length;
    var type = window.pleksearch.current_type;
    header = plektemplate.load_search_overlay_header(total);

    pleksearch.last_search_result = result_object;
    let sorted = pleksearch.sort_results(result_object);

    jQuery.each(sorted, function (key, value) {
      switch (type) {
        case 'event_band':
          result = plektemplate.load_band_item_template(value.data, value.perc) + result;
          break;
        case 'event_venue':
          result = plektemplate.load_venue_item_template(value.data) + result;
          break;
        case 'event_organizer':
          result = plektemplate.load_organizer_item_template(value.data) + result;
          break;
        default:
          break;
      }
    });
    var add_button = false;
    if (type === 'event_band') {
      add_button = "<span><button type='button' id='add-new-band' class='plek-button add-new-vob-button'>" + __('Add new Band', 'plekvetica') + "</button></span>";
    }
    if (type === 'event_venue') {
      add_button = "<span><button type='button' id='add-new-venue' class='plek-button add-new-vob-button'>" + __('Add new Venue', 'plekvetica') + "</button></span>";
    }
    if (type === 'event_organizer') {
      add_button = "<span><button type='button' id='add-new-organizer' class='plek-button add-new-vob-button'>" + __('Add new Organizer', 'plekvetica') + "</button></span>";
    }
    if (add_button !== false) {
      header = plektemplate.load_search_overlay_header(total, add_button);
    }
    return header + result;
  },

  add_item_Eventlistener() {
    jQuery('.plek-add-item').click(function (element) {
      element.preventDefault();
      if (empty(this.dataset.for)) {
        console.warn("Failed to load section identifier");
      }
      window.plekevent.add_item_to_selection(this, this.dataset.for);
    });
  },

  async search(element) {
    var search_for = jQuery('#' + element).val();
    var search_for_prep = this.normalize_band_name(search_for);
    var type = window.pleksearch.current_type;
    console.log(search_for);
    console.log(search_for_prep);

    return pleksearch.get_preloaded_data(type).then(function (data) {
      var results = {};
      //Loop the data object
      jQuery.each(data, function (key, value) {
        var compare_prep = pleksearch.normalize_band_name(value.name);
        try {
          var sm_compare = smith_waterman(search_for_prep, compare_prep, {
            'match': 10,
            'mismatch': -1,
            'gap': -1
          });
        } catch (error) {
          return new Promise(resolve => {
            resolve(false);
          });
        }
        //Dynamic threshold
        //If the input length is less than 20% of the search length, the threshold will be more sensitive.
        let input_length = search_for_prep.length;
        let search_length = sm_compare.pattern.length;
        let threshold = window.pleksearch.threshold;
        if ((input_length / search_length * 100) < 20) {
          threshold = threshold / 2; //Divide the threshold in half, if the input is below 20% 
        }

        var exact_hit = pleksearch.is_exact_hit(search_for_prep, compare_prep);
        if (sm_compare.peak.value >= threshold || exact_hit === true) {
          var item = {};
          item.type = type;
          item.data = value;
          item.class = (exact_hit === true) ? 'exact-hit' : '';
          item.perc = (exact_hit === true) ? 150 : sm_compare.peak.value;
          results[value.id] = item;
        }
        /*if(sm_compare.peak.value > 1){
          console.log("Search: " +  sm_compare.pattern + ' - ' + sm_compare.peak.value + " :: "+input_length+' -- '+search_length + `( threshold ${threshold})`);
        }*/
      });

      return new Promise(resolve => {
        resolve(pleksearch.transport_data(results));
      });
    });



  },

  /**
   * Removes accents, makes lowercase and trims the name.
   * This is used to make the search more robust, as it will match
   * accented characters with their non-accented counterparts.
   * @param {String} name
   * @returns {String}
   */
  normalize_band_name(name) {
    name = name.trim();
    name = name.toLowerCase();
    name = this.convert_accented_characters(name);
    return name;
  },

  /**
   * Converts accented characters in a string to their ASCII equivalents.
   *
   * This function uses a predefined set of regular expressions to replace
   * accented characters with their non-accented counterparts. The conversion
   * covers a wide range of accented characters across different languages.
   *
   * @param {String} str - The string containing accented characters to be converted.
   * @returns {String} The converted string with accented characters replaced by ASCII equivalents.
   */
  convert_accented_characters(str) {
    var conversions = new Object();
    conversions['ae'] = 'ä|æ|ǽ';
    conversions['oe'] = 'ö|œ';
    conversions['ue'] = 'ü';
    conversions['Ae'] = 'Ä';
    conversions['Ue'] = 'Ü';
    conversions['Oe'] = 'Ö';
    conversions['A'] = 'À|Á|Â|Ã|Ä|Å|Ǻ|Ā|Ă|Ą|Ǎ';
    conversions['a'] = 'à|á|â|ã|å|ǻ|ā|ă|ą|ǎ|ª';
    conversions['C'] = 'Ç|Ć|Ĉ|Ċ|Č';
    conversions['c'] = 'ç|ć|ĉ|ċ|č';
    conversions['D'] = 'Ð|Ď|Đ';
    conversions['d'] = 'ð|ď|đ';
    conversions['E'] = 'È|É|Ê|Ë|Ē|Ĕ|Ė|Ę|Ě';
    conversions['e'] = 'è|é|ê|ë|ē|ĕ|ė|ę|ě';
    conversions['G'] = 'Ĝ|Ğ|Ġ|Ģ';
    conversions['g'] = 'ĝ|ğ|ġ|ģ';
    conversions['H'] = 'Ĥ|Ħ';
    conversions['h'] = 'ĥ|ħ';
    conversions['I'] = 'Ì|Í|Î|Ï|Ĩ|Ī|Ĭ|Ǐ|Į|İ';
    conversions['i'] = 'ì|í|î|ï|ĩ|ī|ĭ|ǐ|į|ı';
    conversions['J'] = 'Ĵ';
    conversions['j'] = 'ĵ';
    conversions['K'] = 'Ķ';
    conversions['k'] = 'ķ';
    conversions['L'] = 'Ĺ|Ļ|Ľ|Ŀ|Ł';
    conversions['l'] = 'ĺ|ļ|ľ|ŀ|ł';
    conversions['N'] = 'Ñ|Ń|Ņ|Ň';
    conversions['n'] = 'ñ|ń|ņ|ň|ŉ';
    conversions['O'] = 'Ò|Ó|Ô|Õ|Ō|Ŏ|Ǒ|Ő|Ơ|Ø|Ǿ';
    conversions['o'] = 'ò|ó|ô|õ|ō|ŏ|ǒ|ő|ơ|ø|ǿ|º';
    conversions['R'] = 'Ŕ|Ŗ|Ř';
    conversions['r'] = 'ŕ|ŗ|ř';
    conversions['S'] = 'Ś|Ŝ|Ş|Š';
    conversions['s'] = 'ś|ŝ|ş|š|ſ';
    conversions['T'] = 'Ţ|Ť|Ŧ';
    conversions['t'] = 'ţ|ť|ŧ';
    conversions['U'] = 'Ù|Ú|Û|Ũ|Ū|Ŭ|Ů|Ű|Ų|Ư|Ǔ|Ǖ|Ǘ|Ǚ|Ǜ';
    conversions['u'] = 'ù|ú|û|ũ|ū|ŭ|ů|ű|ų|ư|ǔ|ǖ|ǘ|ǚ|ǜ';
    conversions['Y'] = 'Ý|Ÿ|Ŷ';
    conversions['y'] = 'ý|ÿ|ŷ';
    conversions['W'] = 'Ŵ';
    conversions['w'] = 'ŵ';
    conversions['Z'] = 'Ź|Ż|Ž';
    conversions['z'] = 'ź|ż|ž';
    conversions['AE'] = 'Æ|Ǽ';
    conversions['ss'] = 'ß';
    conversions['IJ'] = 'Ĳ';
    conversions['ij'] = 'ĳ';
    conversions['OE'] = 'Œ';
    conversions['f'] = 'ƒ';
    for (var i in conversions) {
      var re = new RegExp(conversions[i], "g");
      str = str.replace(re, i);
    }
    return str;
  },

  /**
   * Just returns the first parameter. For the Promise of search()... for whatever reason.
   * 
   * @param {mixed} data 
   * @returns 
   */
  transport_data(data) {
    return data;
  },

  /**
   * Sorts the result from the search by percentage
   * @param {object} data 
   * @returns The sorted object 
   */
  sort_results(data) {
    jQuery.each(data, function (key, value) {
      let sliced_key = ("0000000" + key).slice(-7);
      data[value.perc + sliced_key] = value; //Adds the match score to the key to make it sortable.
      delete data[key]; //Remove the original key
    });

    let sorted_arr = Object.keys(data).sort();
    let sorted_obj = new Object;
    jQuery.each(sorted_arr, function (index, key) {
      let sorted_value = data[key];
      sorted_obj[key] = sorted_value; //Adds the value to the sorted obj
    });

    return sorted_obj;
  },
  /**
   * 
   * @param {*} needle 
   * @param {*} haystack 
   * @returns false, if string was not found, true if it is a exact hit.
   */
  is_exact_hit(needle, haystack) {
    var exact_hit = haystack.search(needle); //Returns -1 if String is not found in compare
    if (exact_hit === 0 && haystack.length === needle.length || (needle === haystack)) {
      return true;

    }
    return false;
  },

  async get_preloaded_data(type) {

    return new Promise(resolve => {
      var data = this.get_preloaded_object(type);
      //data.length is bigger than 0
      resolve(data);


    });
    /*if(typeof data !== object){
      plekerror.display_info('Daten laden', 'Es werden noch daten geladen, bitte warten.');
      await setTimeout(get_preloaded_data(type),2000);
    }*/
  },

  get_preloaded_object(type) {
    if (type === 'event_band') {
      var data = window.bandPreloadedData;
    } else if (type === 'event_venue') {
      var data = window.venuePreloadedData;
    } else if (type === 'event_organizer') {
      var data = window.organizerPreloadedData;
    } else {
    }
    return data;
  },


  /**
   * Loads the filtered bands with the given filter parameters.
   * 
   * @param {string[]} countries The countries to filter for.
   * @param {string[]} genres The genres to filter for.
   * @param {string} name The name to filter for.
   * 
   * @returns {Promise} A promise that resolves with true when the filtered bands are loaded successfully.
   */
  load_filtered_bands() {
    const countries = jQuery('#filter-country').val();
    const genres = jQuery('#filter-genre').val();
    const name = jQuery('#filter-band-name').val();
    const loading = '<div class="plek-loader"><i class="fa-solid fa-spinner"></i>' + __('Loading...', 'plekvetica') + '</div>';

    //Activates the loader
    jQuery('.band-filter-bar').parent().append(loading);

    var data = new FormData();

    data.append('action', 'plek_band_actions');
    data.append('do', 'get_filtered_bands');
    data.append('countries', countries);
    data.append('genres', genres);
    data.append('band_name', name);

    return plek_main.send_form(data, false, 'plek_band_filter', (response, button, attr) => {
      const success = plek_main.get_success_item_from_ajax_request(response);
      const countries = attr.countries;
      const genres = attr.genres;
      //Remove the loader and block container
      jQuery('.plek-loader').remove();
      jQuery('.block-container.block-bands').remove();
      //Add the new bands
      jQuery('.band-filter-bar').parent().append(success);
      //Add the filters to the url
      let url_param = {
        countries: countries.join(','),
        genres: genres.join(','),
        band_name: name
      };
      let new_url = plek_main.url_add_filter(url_param, true);
      window.history.pushState({}, "Page", new_url);
      return true;
    }, false, false, { countries: countries, genres: genres, band_name: name });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  pleksearch.register_eventlistener();
});